/* custom */

$(document).ready(function () {
  setTimeout(function () {
    $(".featured_product .rc_radio__onetime").trigger("click");
  }, 600);

  $(".megamenu_title .megamenu_title_inner a").hover(function () {
    var title_id = $(this).closest(".megamenu_title_inner").attr("id");
    $(".megamenu_title .megamenu_title_inner").removeClass("active-link");
    $("#" + title_id).addClass("active-link");
    $(".megamenu_main .megamenu_item_wrapper").css({
      opacity: "0",
      transform: "translateY(60px)",
      display: "none",
    });
    $(".megamenu_main ." + title_id).css({
      opacity: "1",
      transform: "none",
      display: "block",
    });
  });

  $(".js_animation_bar").marquee({
    duration: 15000,
    gap: 10,
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    startVisible: true,
  });

  $(".tweleve_variant_items input").click(function () {
    var price_val = $(this).data("price");
    var input_qty = $(this).data("qty");

    $(this).closest(".common_right").find("#ProductPrice").html(price_val);

    var get_type = $(this)
      .closest("form")
      .find("#rc_radio_options .rc_block__type")
      .find("input:checked")
      .val();
    // var get_price = $(this).closest('form').find('#rc_radio_options .rc_block__type').find('input:checked').next().find('.rc_price').data('dprice');

    // prive customization
    // get_type = 'autodelivery'
    // get discount for subscribe page
    discount = document
      .querySelector(`.single-option-radio`)
      .querySelector(`input:checked`)
      .getAttribute("discount");

    // get discount for home page
    if (!discount) {
      value = $(this)[0].form.querySelector(
        "#rc_shipping_interval_frequency"
      ).value;
      if (value == 2) {
        discount = 15;
      } else if (value == 4) {
        discount = 12;
      } else if (value == 8) {
        discount = 12;
      }
    }
    get_price =
      Number(price_val.replace(/[^0-9.-]+/g, "")) * (1 - discount / 100);
    one_time_price = Number(price_val.replace(/[^0-9.-]+/g, ""));
    // update the 1 time price

    // if(get_type == 'autodeliver'){
    // var final_change_price = parseFloat(get_price * input_qty);

    // $('.product_templ_price .original_prices').html(price_val);
    // $('.product_templ_price .append_price').html(theme.Currency.formatMoney(final_change_price, theme.strings.moneyFormat));

    // $(this).closest('.common_right').find('.original_prices').html(price_val);
    // $(this).closest('.common_right').find('.append_price').html(theme.Currency.formatMoney(final_change_price, theme.strings.moneyFormat));

    // }else{

    if (String(get_type) == "onetime") {
      console.log("setting 1 time price");
      $(".product_templ_price .original_prices").html(" ");
      $(this).closest(".common_right").find(".original_prices").html(" ");
      $(".product_templ_price .append_price").html(" ");
      $(this)
        .closest(".common_right")
        .find(".append_price")
        .html(
          theme.Currency.formatMoney(
            one_time_price * 100,
            theme.strings.moneyFormat
          )
        );

      var one_time_p = parseFloat((one_time_price * 10) / 100);
      var one_time_price_original = parseFloat(one_time_price - one_time_p);

      $(".featured_product .original_prices").html(
        theme.Currency.formatMoney(
          one_time_price * 100,
          theme.strings.moneyFormat
        )
      );
      $(".featured_product .append_price").html(
        theme.Currency.formatMoney(
          one_time_price_original * 100,
          theme.strings.moneyFormat
        )
      );
    } else {
      console.log("setting sub price");
      $(".product_templ_price .original_prices").html(" ");
      $(this)
        .closest(".common_right")
        .find(".original_prices")
        .html(
          theme.Currency.formatMoney(
            one_time_price * 100,
            theme.strings.moneyFormat
          )
        );

      $(".product_templ_price .append_price").html(" ");
      $(this)
        .closest(".common_right")
        .find(".append_price")
        .html(
          theme.Currency.formatMoney(get_price * 100, theme.strings.moneyFormat)
        );

      $(".featured_product .original_prices").html(
        theme.Currency.formatMoney(
          one_time_price * 100,
          theme.strings.moneyFormat
        )
      );
      $(".featured_product .append_price").html(
        theme.Currency.formatMoney(get_price * 100, theme.strings.moneyFormat)
      );
    }
  });

  $("#rc_radio_options .rc_block__type input").click(function () {
    // turn off subscriptions
    console.log("turning off stuff");
    console.log($(this));
  });

  $("#rc_radio_options .rc_block__type input").click(function () {
    var input_html = $(this).next().find(".rc_price").data("dprice");
    var input_gethtml = $(this)
      .closest("form")
      .find(".rc_block__type")
      .find("#rc_price_onetime")
      .data("dprice");
    var get_type = $(this)
      .parent(".rc_block__type")
      .find("input:checked")
      .val();
    var selected_input = $(this)
      .closest("form")
      .find(".tweleve_variant_items input:checked")
      .data("qty");
    var final_subs_price = parseFloat(selected_input * input_html);

    var one_time_subscribe = parseFloat(selected_input * input_gethtml);
    var append_price_color = false;

    var frequency_selected = $("#rc_shipping_interval_frequency").val();

    if (get_type == "autodeliver") {
      $(".product_templ_price .original_prices").html(
        theme.Currency.formatMoney(
          one_time_subscribe,
          theme.strings.moneyFormat
        )
      );
      $(this)
        .closest(".common_right")
        .find(".original_prices")
        .html(
          theme.Currency.formatMoney(
            one_time_subscribe,
            theme.strings.moneyFormat
          )
        );

      $(".featured_product .original_prices")
        .html(
          theme.Currency.formatMoney(
            one_time_subscribe,
            theme.strings.moneyFormat
          )
        )
        .removeClass("remove_cross");
      $(".featured_product .append_price").html(
        theme.Currency.formatMoney(final_subs_price, theme.strings.moneyFormat)
      );
      $(".featured_product .discount_badge.one-time").addClass("hide");
      $(".featured_product .discount_badge.subscribe").removeClass("hide");

      if (frequency_selected == 2) {
        $(".add_discount_text").html("15");
      } else {
        $(".add_discount_text").html("12");
      }

      $(this)
        .siblings(".rc_label__autodeliver")
        .find(".variant_price_single .append_price")
        .removeClass("hide");
      $(this)
        .closest("#rc_radio_options")
        .find(".rc_label__onetime .append_price")
        .addClass("hide");
      var val = $(this)
        .closest("form")
        .find("#rc_shipping_interval_frequency")
        .val();
      var sp = "1186693309";
      if (val == 2) {
        sp = "1186660541";
      } else if (val == 4) {
        sp = "1186693309";
      } else if (val == 8) {
        sp = "1186758845";
      }
      $(this)
        .closest("form")
        .find('input[name="selling_plan"]')
        .attr("value", sp);

      $(
        ".try_featured_product .product-block--price.try_product_main_price"
      ).css("display", "none");
      $(
        ".try_featured_product .product-block--price.try_product_subscribe_price"
      ).css("display", "block");
    } else {
      // force check radio button
      $(this).prop("checked", true);
      $(this).attr("checked", "checked");

      var one_time_main = parseFloat(selected_input * input_html);
      var one_time_p = parseFloat((one_time_main * 10) / 100);
      var one_time_price = parseFloat(one_time_main - one_time_p);

      $(".product_templ_price .original_prices").html(" ");

      $(".featured_product .append_price").html(
        theme.Currency.formatMoney(one_time_price, theme.strings.moneyFormat)
      );
      $(".featured_product .discount_badge.one-time").removeClass("hide");
      $(".featured_product .discount_badge.subscribe").addClass("hide");
      $(".add_discount_text").html("10");

      // $('.featured_product .original_prices').addClass('remove_cross');
      $(".featured_product .original_prices").html(
        theme.Currency.formatMoney(final_subs_price, theme.strings.moneyFormat)
      );

      $(this).closest(".common_right").find(".original_prices").html(" ");
      append_price_color = true;

      $(this)
        .siblings(".rc_label__onetime")
        .find(".variant_price_single .append_price")
        .removeClass("hide");
      $(this)
        .closest("#rc_radio_options")
        .find(".rc_label__autodeliver .append_price")
        .addClass("hide");;
      $(this)
        .closest("form")
        .find('input[name="selling_plan"]')
        .attr("value", "");

      $(
        ".try_featured_product .product-block--price.try_product_subscribe_price"
      ).css("display", "none");
      $(
        ".try_featured_product .product-block--price.try_product_main_price"
      ).css("display", "block");
    }

    $(".product_templ_price .append_price")
      .html(
        theme.Currency.formatMoney(final_subs_price, theme.strings.moneyFormat)
      )
      .css("color", "#E21B79");
    $(this)
      .closest(".common_right")
      .find(".append_price")
      .html(
        theme.Currency.formatMoney(final_subs_price, theme.strings.moneyFormat)
      )
      .css("color", "#E21B79");

    if (append_price_color == true) {
      $(this)
        .closest(".common_right")
        .find(".append_price")
        .css("color", "#042181");
      $(this)
        .closest(".product_templ_price")
        .find(".append_price")
        .css("color", "#042181");
    }
  });

  $(".tweleve_addtocart").click(function (e) {
    var ad_flag = false;
    if ($(this).hasClass("mocktail_ad")) {
      ad_flag = true;
    }
    console.log("prevent default 1");
    e.preventDefault();
    var item_qty = $(this)
      .closest("form")
      .find(".tweleve_variant_items")
      .find("input:checked")
      .data("qty");
    $(this)
      .closest("form")
      .append('<input type="hidden" value="' + item_qty + '" name="quantity">');
    var button_this = $(this);

    // var form_id =  $(this).closest('form').attr('id');
    var theForm = $(this).closest("form");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: theForm.serialize(),
      beforeSend: function () {
        button_this.addClass("btn--loading");
      },
      success: function (data) {
        button_this.removeClass("btn--loading");

        if (ad_flag == true) {
          if (
            $(".featured_product .rc_block__type input:checked").val() ==
            "onetime"
          ) {
            window.location.href = "/checkout?discount=VARIETYPACK10";
          } else {
            window.location.href = "/checkout";
          }
        } else {
          var drawer_new = new theme.CartDrawer();
          drawer_new.open();
          $(".collection_product_list .product_popup").addClass(
            "content_hidden"
          );
          $(".overlay").addClass("hide");
        }
      },
    });
  });

  $(".mocktil_set_pro").click(function (e) {
    console.log("prevent default 2");
    e.preventDefault();

    var button_this = $(this);

    var form_id = $(this).data("vid");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        quantity: 1,
        id: form_id,
      },
      beforeSend: function () {
        button_this.addClass("btn--loading");
      },
      success: function (data) {
        button_this.removeClass("btn--loading");
        var drawer_new = new theme.CartDrawer();
        drawer_new.open();
      },
    });
  });

  function reChargeGetCookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
  }

  function reChargeReDirection(redirect_url) {
    // Re-direct customer to desired URL
    window.location.href = redirect_url;
  }

  function reChargeBuildCheckoutURL() {
    // Build the Checkout URL
    var myshopify_domain = "drinkwildwonder.myshopify.com";

    var token = reChargeGetCookie("cart");
    try {
      // Cross-domain tracking with Google Analytics
      var ga_linker = ga.getAll()[0].get("linkerParam");
    } catch (e) {
      // 'ga' is not available
      var ga_linker = "";
    }
    // Customer email address for use in the Checkout URL
    var customer_param =
      "{% if customer %}customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}";

    var checkout_url =
      "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
      myshopify_domain +
      "&cart_token=" +
      token +
      "&" +
      ga_linker +
      "&" +
      customer_param;

    window.location.href = checkout_url;
  }

  $("body").on("touchstart click", ".ajaxcart__checkout", function (e) {
    console.log("prevent default 3");
    e.preventDefault();
    var token = reChargeGetCookie("cart");

    if (
      $("body")
        .find(".ajaxcart__inner .ajaxcart__product")
        .hasClass("subcribe_product")
    ) {
      reChargeBuildCheckoutURL();
    } else if (
      $("body")
        .find(".cart__products .cart__product")
        .hasClass("subcribe_product")
    ) {
      reChargeBuildCheckoutURL();
    } else {
      window.location.href = "/checkout";
    }
  });

  var text_number = -1000;
  var temp = 0;

  $(window).scroll(function () {
    requestAnimationFrame(function () {
      var docViewTopv = $(window).scrollTop();
      var docViewBottomv = docViewTopv + $(window).height();

      $(".curve_text_svg").each(function () {
        var elemTopv = $(this).offset().top;
        var elemBottomv = elemTopv + $(this).height();

        if (elemTopv <= docViewBottomv && elemBottomv >= docViewTopv) {
          if (temp < docViewTopv) {
            text_number = text_number - 10;
            $(this).find(".textPath_curve").attr("startOffset", text_number);
          } else {
            text_number = text_number + 10;
            $(this).find(".textPath_curve").attr("startOffset", text_number);
          }
          temp = docViewTopv;
        }
      });
    });
  });

  $(".product_accordion .acco_icon  ").click(function () {
    $(this)
      .closest(".product_accordion_content")
      .find(".ingredients")
      .slideToggle("slow");
    $(this)
      .closest(".product_accordion_content")
      .find(".product_below_content_image")
      .slideToggle("slow");
    $(this)
      .closest(".product_accordion_content")
      .find(".acco_icon .icon_plus")
      .toggleClass("hide");
    $(this)
      .closest(".product_accordion_content")
      .find(".acco_icon .icon_minus")
      .toggleClass("hide");
  });

  $(".learn_faq_title_icon").click(function () {
    var accordion = $(this).parent().hasClass("active_tab");
    if (accordion) {
      $(this).parent(".learn_faq_title_answer_cover").removeClass("active_tab");
      $(this).next().slideUp();
      $(this).find(".content_acco_icon .icon_minus").addClass("hide");
      $(this).find(".content_acco_icon .icon_plus").removeClass("hide");
    } else {
      $(this).next().slideDown();
      $(this).parent(".learn_faq_title_answer_cover").addClass("active_tab");

      $(this).find(".content_acco_icon .icon_minus").removeClass("hide");
      $(this).find(".content_acco_icon .icon_plus").addClass("hide");
    }
  });

  $(".subs_product_radio .subs_product_option_radio").change(function () {
    console.log("clicky");
    var subs_value = $(this).val();

    $(".rc_label__deliver_every .rc_select option").removeAttr("selected");
    $(".rc_label__deliver_every .rc_select option").each(function () {
      if ($(this).val() == subs_value) {
        $(this).attr("selected", "selected");
      }
    });
  });

  $(
    '.collection_product_list .collection_product_list_header input[type="radio"]'
  ).change(function () {
    var radio_id = $(this).attr("id");
    $(".collection_product_list .product_block_wrapper").addClass(
      "content_hidden"
    );
    $(".collection_product_list ." + radio_id).removeClass("content_hidden");
  });

  $(".collection_product_list .popup_open_btn").click(function () {
    var product_id = $(this).attr("id");

    $(".collection_product_list .product_popup").addClass("content_hidden");
    $(".collection_product_list ." + product_id).removeClass("content_hidden");
    $(".overlay").removeClass("hide");
  });

  $(".overlay, .collection_product_list .popup_close_btn").click(function () {
    $(".collection_product_list .product_popup").addClass("content_hidden");
    $(".overlay").addClass("hide");
  });

  $(".site-nav--has-dropdown, .megamenu ").hover(function () {
    $(this)
      .find(".site-nav__link--has-dropdown svg")
      .css("transform", "rotate(0deg)");
    if ($(this).find(".megamenu").css("opacity") == "0") {
      $(this)
        .find(".site-nav__link--has-dropdown svg")
        .css("transform", "rotate(180deg)");
    }
  });

  $(".slideshow-wrapper .link_to_next_section_btn").click(function () {
    var cls = $(this).closest(".shopify-section").next().offset().top;
    $("html, body").animate({ scrollTop: cls }, "slow");
  });

  function reChargeGetCookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
  }

  function reChargeReDirection(redirect_url) {
    // Re-direct customer to desired URL
    window.location.href = redirect_url;
  }

  function reChargeBuildCheckoutURL() {
    // Build the Checkout URL
    var myshopify_domain = "drinkwildwonder.myshopify.com";

    var token = reChargeGetCookie("cart");
    try {
      // Cross-domain tracking with Google Analytics
      var ga_linker = ga.getAll()[0].get("linkerParam");
    } catch (e) {
      // 'ga' is not available
      var ga_linker = "";
    }
    // Customer email address for use in the Checkout URL
    var customer_param =
      "{% if customer %}customer_id={{ customer.id }}&customer_email={{ customer.email }}{% endif %}";

    var checkout_url =
      "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
      myshopify_domain +
      "&cart_token=" +
      token +
      "&" +
      ga_linker +
      "&" +
      customer_param;

    window.location.href = checkout_url;
  }

  $("body").on("touchstart click", ".ajaxcart__checkout", function (e) {
    console.log("prevent default 4");
    e.preventDefault();
    var token = reChargeGetCookie("cart");

    if (
      $("body")
        .find(".drawer__contents .cart__item")
        .hasClass("subcribe_product")
    ) {
      reChargeBuildCheckoutURL();
    } else {
      window.location.href = "/checkout";
    }
  });

  $(".product_list .product_list_image_wrapper ").each(function () {
    var pro_class_act = $(this).hasClass("active");
    if (pro_class_act) {
      $(this)
        .parents(".product_list")
        .find(".product_list_title_wrapper .product_list_pro_title")
        .css("display", "inline-block");
    }
  });

  $(".custom_popup_btn, .announcement_popup_open").click(function (e) {
    e.preventDefault();
    $("html").addClass("modal-open custom_modal_open");
    $(".custom_popup").addClass("modal--is-active");
  });

  $(".custom_popup .js-modal-close").click(function () {
    $("html").removeClass("modal-open custom_modal_open");
    $("html").addClass("modal-closing");
    $(".custom_popup").removeClass("modal--is-active");
    $(".custom_popup").addClass("modal--is-closing");

    setTimeout(function () {
      $("html").removeClass("modal-closing");
      $(".custom_popup").removeClass("modal--is-closing");
    }, 500);
  });

  $("body").on(
    "click",
    '.homepage_banner_main .homepage_banner_scroll_btn[href^="#"]',
    function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top - 100,
        },
        500
      );
    }
  );

  $(".product_shark_addtocart").click(function (e) {
    e.preventDefault();
    var v_id = $(this).data("vid");
    var button_this = $(this);

    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/add.js?id=" + v_id + "&quantity=1",

      beforeSend: function () {
        button_this.addClass("btn--loading");
      },
      success: function (data) {
        button_this.removeClass("btn--loading");
        var drawer_new = new theme.CartDrawer();
        drawer_new.open();
      },
    });
  });

  $(".custom_product__quantity .js-qty__adjust").click(function () {
    var p_price = $(this).data("product-price");
    var p_qty = $(this).closest(".js-qty__wrapper").find(".js-qty__num").val();
    var new_price = p_price * p_qty;
    $(".page_product .product-single__meta .product_original_price").html(
      theme.Currency.formatMoney(new_price, theme.strings.moneyFormat)
    );

    var p_compareat_price = $(this).data("product-compareat-price");
    var new_comapreat_price = p_compareat_price * p_qty;
    $(".page_product .product-single__meta .product__price--compare").html(
      theme.Currency.formatMoney(new_comapreat_price, theme.strings.moneyFormat)
    );
    $(
      ".page_product .product-single__meta .shark_tank_bundle_discount_price"
    ).html(
      theme.Currency.formatMoney(new_comapreat_price, theme.strings.moneyFormat)
    );
  });

  $(".featured-flavors_main .popup_open_btn").click(function () {
    var product_id = $(this).attr("id");

    $(".featured-flavors_main ." + product_id).removeClass("content_hidden");
    $(".overlay").removeClass("hide");
  });

  $(".overlay, .featured-flavors_main .popup_close_btn").click(function () {
    $(".featured-flavors_main .product_popup").addClass("content_hidden");
    $(".overlay").addClass("hide");
  });

  $(".featured-flavors-addtocart-btn").click(function (e) {
    e.preventDefault();
    var quantity = 1;
    var variant_id = $(this).attr("id");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: variant_id,
      },
      dataType: "json",
      success: function () {
        window.location.href = "/checkout"; // Redirect to the checkout page
      },
    });
  });

  $(".featured_product #rc_shipping_interval_frequency").change(function () {
    setTimeout(function () {
      if ($("#rc_shipping_interval_frequency").val() == 2) {
        $(".discount_badge.subscribe span").html("15");
        $(".add_discount_text").html("15");
      } else {
        $(".discount_badge.subscribe span").html("12");
        $(".add_discount_text").html("12");
      }
    }, 100);
  });

  $(".announcement_animation").marquee({
    duration: 20000,
    gap: 200,
    delayBeforeStart: 0,
    direction: "left",
    duplicated: true,
    startVisible: true,
  });

  // Product form (with selling plan)
  // Toggle purchase type
  $('.js-purchase-type').on('input', (e) => {
    const form = e.target.closest('.js-product-form')

    form.querySelectorAll('.js-selling-plan-group').forEach(el => {
      if (e.target.closest('.js-selling-plan-group').isSameNode(el)) {
        el.classList.add('active')
      } else {
        el.classList.remove('active')
      }
    })

    if (e.target.value === 'subscribe') {
      form.querySelector('.js-selling-plan').setAttribute('name', 'selling_plan')
    } else {
      form.querySelector('.js-selling-plan').removeAttribute('name')
    }
  })

  $('.js-selling-plan').on('input', e => {
    const form = e.target.closest('.js-product-form')
    const id = form.querySelector('[name="id"]').value
    const selectedOption = e.target.options[e.target.selectedIndex]
    const discountValue = Number(selectedOption.dataset.discountValue)
    const productData = JSON.parse(form.querySelector('[type="application/json"]').textContent)
    const variant = productData.variants.find(e => +e.id === +id)
    const priceFinal = variant.price * (100 - discountValue) / 100

    form.querySelectorAll('.js-discount').forEach(node => node.innerHTML = discountValue)
    form.querySelectorAll('.js-price').forEach(node => node.innerHTML = theme.Currency.formatMoney(priceFinal, theme.strings.moneyFormat))
    form.querySelectorAll('.js-price-compare').forEach(node => node.innerHTML = theme.Currency.formatMoney(variant.price, theme.strings.moneyFormat))
  })
});

// document.addEventListener("contextmenu", function (e) {
//   e.preventDefault();
// });

document.addEventListener('cart:refresh', async () => {
  const html = await fetch('/cart?view=ajax-bundle').then(res => res.text())

  document.querySelectorAll('[data-smartcart-items] [data-bundle-item]').forEach(el => el.remove())
  if (!!document.querySelector('[data-smartcart-items]')) document.querySelector('[data-smartcart-items]').insertAdjacentHTML('afterbegin', html)
})

document.addEventListener('click', async e => {
  if (!e.target.closest('.js-bundle-remove')) return;

  const bundleId = e.target.closest('.js-bundle-remove').dataset.bundleId
  const updates = {}
  const items = window.Rebuy.SmartCart.cart.items.filter(item => item.properties?._bundle_id === bundleId)
    .map(item => updates[item.key] = 0)


  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates })
  })
  .then(response => {
    return response.json();
  })

  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
    detail: {
    }
  }));
})